import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatDate, formatCurrency } from '../utils/helpers';

export const generateCertificadoPDF = (garantia) => {
  const doc = new jsPDF();
  
  doc.setFillColor(30, 64, 175);
  doc.rect(0, 0, 210, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.setFont(undefined, 'bold');
  doc.text('EUREKA', 20, 20);
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text('RD Garantia - Sistema de Gestion', 20, 28);
  
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text('CERTIFICADO DE GARANTIA', 105, 55, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(`Numero: ${garantia.numeroGarantia}`, 20, 70);
  doc.text(`Fecha de emision: ${formatDate(garantia.fechaAlta)}`, 20, 77);
  doc.text(`Valido hasta: ${formatDate(garantia.fechaVencimiento)}`, 20, 84);
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('DATOS DEL VEHICULO', 20, 100);
  
  doc.autoTable({
    startY: 105,
    head: [['Campo', 'Valor']],
    body: [
      ['Matricula', garantia.vehiculo.matricula],
      ['Bastidor', garantia.vehiculo.bastidor],
      ['Marca', garantia.vehiculo.marca],
      ['Modelo', garantia.vehiculo.modelo],
      ['Version', garantia.vehiculo.version],
      ['Año', garantia.vehiculo.year],
      ['Combustible', garantia.vehiculo.combustible],
      ['Potencia', `${garantia.vehiculo.potencia} CV`],
      ['Color', garantia.vehiculo.color]
    ],
    theme: 'striped',
    headStyles: { fillColor: [30, 64, 175] }
  });
  
  const finalY = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('DATOS DEL PROPIETARIO', 20, finalY);
  
  doc.autoTable({
    startY: finalY + 5,
    head: [['Campo', 'Valor']],
    body: [
      ['Nombre', garantia.propietario.nombre],
      ['DNI', garantia.propietario.dni],
      ['Telefono', garantia.propietario.telefono],
      ['Email', garantia.propietario.email],
      ['Direccion', garantia.propietario.direccion],
      ['Ciudad', garantia.propietario.ciudad],
      ['Codigo Postal', garantia.propietario.codigoPostal]
    ],
    theme: 'striped',
    headStyles: { fillColor: [30, 64, 175] }
  });
  
  const finalY2 = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('COBERTURA', 20, finalY2);
  
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text(`Nivel: ${garantia.nivelNombre}`, 20, finalY2 + 7);
  doc.text(`Precio: ${formatCurrency(garantia.precio)}`, 20, finalY2 + 14);
  
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('Este certificado es valido y verificable en el sistema EUREKA', 105, 280, { align: 'center' });
  doc.text('RD Garantia S.L. - CIF: B12345678', 105, 285, { align: 'center' });
  
  doc.save(`certificado-${garantia.numeroGarantia}.pdf`);
};

export const generateJustificanteAutorizacionPDF = (averia, garantia) => {
  const doc = new jsPDF();
  
  doc.setFillColor(30, 64, 175);
  doc.rect(0, 0, 210, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.setFont(undefined, 'bold');
  doc.text('EUREKA', 20, 20);
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text('RD Garantia - Sistema de Gestion', 20, 28);
  
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text('JUSTIFICANTE DE AUTORIZACION', 105, 55, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(`Numero de Averia: ${averia.numeroAveria}`, 20, 70);
  doc.text(`Fecha de Autorizacion: ${formatDate(averia.fechaAutorizacion)}`, 20, 77);
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('DATOS DE LA AVERIA', 20, 95);
  
  doc.autoTable({
    startY: 100,
    head: [['Campo', 'Valor']],
    body: [
      ['Tipo', averia.tipo],
      ['Descripcion', averia.descripcion],
      ['Fecha Reporte', formatDate(averia.fechaReporte)],
      ['Coste Estimado', formatCurrency(averia.costeEstimado)],
      ['Taller', averia.taller],
      ['Estado', 'AUTORIZADA']
    ],
    theme: 'striped',
    headStyles: { fillColor: [34, 197, 94] }
  });
  
  const finalY = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('VEHICULO AFECTADO', 20, finalY);
  
  doc.autoTable({
    startY: finalY + 5,
    head: [['Campo', 'Valor']],
    body: [
      ['Matricula', garantia.vehiculo.matricula],
      ['Marca/Modelo', `${garantia.vehiculo.marca} ${garantia.vehiculo.modelo}`],
      ['Propietario', garantia.propietario.nombre],
      ['Garantia', garantia.numeroGarantia]
    ],
    theme: 'striped',
    headStyles: { fillColor: [30, 64, 175] }
  });
  
  const finalY2 = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('EVIDENCIA LEGAL', 20, finalY2);
  
  if (averia.evidenciaLegal) {
    doc.autoTable({
      startY: finalY2 + 5,
      head: [['Campo', 'Valor']],
      body: [
        ['Timestamp', averia.evidenciaLegal.timestamp],
        ['Autorizado por', averia.autorizadoPor],
        ['IP', averia.evidenciaLegal.ip],
        ['Hash', averia.evidenciaLegal.hash.substring(0, 32) + '...']
      ],
      theme: 'striped',
      headStyles: { fillColor: [239, 68, 68] }
    });
  }
  
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('Este documento tiene validez legal y esta registrado en el sistema', 105, 280, { align: 'center' });
  doc.text('RD Garantia S.L. - CIF: B12345678', 105, 285, { align: 'center' });
  
  doc.save(`justificante-${averia.numeroAveria}.pdf`);
};

export const generateFacturaPDF = (factura, averias) => {
  const doc = new jsPDF();
  
  doc.setFillColor(30, 64, 175);
  doc.rect(0, 0, 210, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.setFont(undefined, 'bold');
  doc.text('EUREKA', 20, 20);
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text('RD Garantia - Sistema de Gestion', 20, 28);
  
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text('FACTURA', 105, 55, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text(`Numero: ${factura.numeroFactura}`, 20, 70);
  doc.text(`Fecha: ${formatDate(factura.fecha)}`, 20, 77);
  doc.text(`Estado: ${factura.estado.toUpperCase()}`, 20, 84);
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('DETALLE DE AVERIAS', 20, 100);
  
  const averiasData = averias.map(a => [
    a.numeroAveria,
    a.tipo,
    formatDate(a.fechaReporte),
    formatCurrency(a.costeReal || a.costeEstimado)
  ]);
  
  doc.autoTable({
    startY: 105,
    head: [['Numero', 'Tipo', 'Fecha', 'Importe']],
    body: averiasData,
    theme: 'striped',
    headStyles: { fillColor: [30, 64, 175] },
    foot: [['', '', 'SUBTOTAL', formatCurrency(factura.importeBase)]],
    footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' }
  });
  
  const finalY = doc.lastAutoTable.finalY + 10;
  
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('RESUMEN', 140, finalY);
  
  doc.autoTable({
    startY: finalY + 5,
    body: [
      ['Base Imponible', formatCurrency(factura.importeBase)],
      ['IVA (21%)', formatCurrency(factura.iva)],
      ['Retencion (15%)', formatCurrency(factura.retencion)],
      ['TOTAL', formatCurrency(factura.total)]
    ],
    theme: 'plain',
    startX: 120,
    columnStyles: {
      0: { fontStyle: 'bold', halign: 'right' },
      1: { halign: 'right' }
    }
  });
  
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('RD Garantia S.L. - CIF: B12345678 - C/ Ejemplo 123, Madrid', 105, 280, { align: 'center' });
  doc.text('Tel: 900 123 456 - Email: facturacion@rdgarantia.com', 105, 285, { align: 'center' });
  
  doc.save(`factura-${factura.numeroFactura}.pdf`);
};

export const generateInformeLiquidacionPDF = (mes, year, garantias, averias, facturas) => {
  const doc = new jsPDF();
  
  doc.setFillColor(30, 64, 175);
  doc.rect(0, 0, 210, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28);
  doc.setFont(undefined, 'bold');
  doc.text('EUREKA', 20, 20);
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text('RD Garantia - Sistema de Gestion', 20, 28);
  
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(20);
  doc.setFont(undefined, 'bold');
  doc.text('INFORME DE LIQUIDACION MENSUAL', 105, 55, { align: 'center' });
  
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text(`Periodo: ${mes}/${year}`, 105, 65, { align: 'center' });
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text('RESUMEN EJECUTIVO', 20, 85);
  
  const totalGarantias = garantias.length;
  const totalAverias = averias.length;
  const totalFacturado = facturas.reduce((sum, f) => sum + f.total, 0);
  const totalCostes = averias.reduce((sum, a) => sum + (a.costeReal || a.costeEstimado), 0);
  
  doc.autoTable({
    startY: 90,
    body: [
      ['Garantias Emitidas', totalGarantias.toString()],
      ['Averias Gestionadas', totalAverias.toString()],
      ['Total Facturado', formatCurrency(totalFacturado)],
      ['Total Costes', formatCurrency(totalCostes)],
      ['Beneficio Neto', formatCurrency(totalFacturado - totalCostes)]
    ],
    theme: 'striped',
    headStyles: { fillColor: [30, 64, 175] },
    columnStyles: {
      0: { fontStyle: 'bold' },
      1: { halign: 'right' }
    }
  });
  
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generado el ${formatDate(new Date())}`, 105, 280, { align: 'center' });
  doc.text('RD Garantia S.L. - Documento Confidencial', 105, 285, { align: 'center' });
  
  doc.save(`informe-liquidacion-${mes}-${year}.pdf`);
};
